/* eslint-disable no-unused-vars */
import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';
import { FontSize } from '../../../../asset/styles';

const StyledMessage = styled.div`
  flex: 1;
  font-size: ${FontSize.small};
`;

/**
 * Header message(title) container
 * - title を `\n` 改行コードで分解し `<br>` はさみ出力します
 * - ref - message container mount 後の高さを取得するために使用します - 前バージョンで実装されていました
 * @type {React.ComponentType<{message?: *} & React.ClassAttributes<any>>}
 * @return {*} React.node - Header message(title) container を返します
 */
const HeaderMessage = forwardRef(
  ({ message, ...props }, ref) =>
    message && (
      <StyledMessage className={'HeaderMessage'} innerRef={ref} {...props}>
        {message.split('\n').map((item, key) => (
          <span
            key={`message-text-${key}`}
            className={`message-text-${key}`}
            style={{ wordBreak: 'break-all', display: 'inline-block' }}
          >
            {item}
            <br />
          </span>
        ))}
      </StyledMessage>
    )
);

export default HeaderMessage;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/header/HeaderMessage.js